import React from 'react';
import { cn } from './cn';
import { Spinner } from './feedback';

// Clean editorial data table. columns: [{ key, header, align, render, className }].
// Rows do NOT animate (per-row reveal is annoying on data); the table sits inside a Bezel by
// the caller. align: 'left' | 'right' | 'center'.
export function Table({ columns, rows, keyField = '_id', onRowClick, loading, empty }) {
    const alignCls = { left: 'text-left', right: 'text-right', center: 'text-center' };

    if (loading) {
        return <div className="flex justify-center py-16"><Spinner /></div>;
    }
    if (!rows || rows.length === 0) {
        return <div className="px-6 py-14 text-center text-sm text-espresso-soft/70">{empty || 'Chưa có dữ liệu'}</div>;
    }

    return (
        <div className="overflow-x-auto">
            <table className="w-full border-collapse">
                <thead>
                    <tr>
                        {columns.map(c => (
                            <th key={c.key} className={cn(
                                'whitespace-nowrap px-3 py-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-espresso-soft/70 md:px-5 md:py-3.5',
                                alignCls[c.align || 'left'],
                            )}>
                                {c.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={row[keyField] ?? i}
                            onClick={onRowClick ? () => onRowClick(row) : undefined}
                            className={cn(
                                'border-t border-espresso/[0.06] transition-colors duration-200',
                                onRowClick && 'cursor-pointer hover:bg-espresso/[0.03]',
                            )}>
                            {columns.map(c => (
                                <td key={c.key} className={cn('px-3 py-3 text-sm text-espresso md:px-5 md:py-4', alignCls[c.align || 'left'], c.className)}>
                                    {c.render ? c.render(row) : row[c.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
